import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Mail, Lock, Loader2 } from "lucide-react";
import { useAuth } from "../AuthContext";
import { toast } from "sonner";
import { ScanEyeLogoPrueba } from "../components/ScanEyeLogoPrueba";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) {
      toast.success("Acceso autorizado");
      navigate("/app");
    } else {
      toast.error(r.error || "Credenciales inválidas");
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#000] text-white relative overflow-hidden">
      {/* Grid */}
      <div className="fixed inset-0 pointer-events-none" style={{ backgroundImage: 'linear-gradient(rgba(255,255,255,.016) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.016) 1px,transparent 1px)', backgroundSize: '72px 72px' }} />
      {/* Ambient orbs */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div className="orb-float absolute rounded-full" style={{ width: 600, height: 600, top: -200, right: -150, background: 'radial-gradient(circle, rgba(222,255,154,0.06) 0%, transparent 65%)' }} />
        <div className="orb-float-2 absolute rounded-full" style={{ width: 480, height: 480, bottom: -140, left: -80, background: 'radial-gradient(circle, rgba(0,87,255,0.05) 0%, transparent 65%)' }} />
      </div>

      <div className="relative flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <Link to="/" className="flex items-center gap-2 mb-10">
            <ScanEyeLogoPrueba size="sm" />
          </Link>

          <h1 className="font-display text-4xl tracking-tighter mb-2">Acceso forense</h1>
          <p className="text-[#8A8F98] text-sm mb-8">
            Introduce tus credenciales para acceder a los motores de análisis.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="relative">
              <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#5A5F68]" />
              <input
                data-testid="login-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@empresa.com"
                className="se-input w-full bg-[#0A0A0A] border border-[#1F2428] rounded-lg pl-11 pr-4 py-3 text-white placeholder:text-[#5A5F68] outline-none transition-all"
              />
            </div>
            <div className="relative">
              <Lock size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#5A5F68]" />
              <input
                data-testid="login-password-input"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="se-input w-full bg-[#0A0A0A] border border-[#1F2428] rounded-lg pl-11 pr-4 py-3 text-white placeholder:text-[#5A5F68] outline-none transition-all"
              />
            </div>
            <button
              data-testid="login-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full text-black font-bold rounded-lg py-3 transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-50 relative overflow-hidden"
              style={!loading ? { background: 'linear-gradient(110deg, #c8ff6e, #DEFF9A, #f0ffbe, #DEFF9A, #c8ff6e)', backgroundSize: '200% auto', animation: 'shimmer 3s linear infinite' } : { background: '#DEFF9A' }}
            >
              {loading && <Loader2 size={16} className="animate-spin" />}
              {loading ? "Verificando..." : "Iniciar sesión"}
            </button>
          </form>

          <div className="text-center mt-4">
            <Link to="/recuperar-password" className="text-xs text-[#8A8F98] hover:text-[#DEFF9A] transition-colors">
              ¿Has olvidado tu contraseña?
            </Link>
          </div>

          <p className="text-center text-sm text-[#8A8F98] mt-6">
            ¿No tienes cuenta?{" "}
            <Link to="/register" data-testid="login-to-register" className="text-[#DEFF9A] hover:underline">
              Crear cuenta
            </Link>
          </p>

          <div className="text-center text-[10px] font-mono uppercase tracking-[0.22em] text-[#5A5F68] mt-10 leading-relaxed">
            ScanEye Labs <span className="text-[#DEFF9A]/60">|</span> Tecnología de Verificación Forense<br />por Antonio Moya Miralles
          </div>
        </div>
      </div>
    </div>
  );
}
